/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { Link } from "react-router-dom";

export const MARYSE_PHOTO = "/maryse-galita.jpg";

// ===============================================================
// Encadré "Votre formatrice" — à insérer juste avant le bouton
// Acheter sur chaque page formation.
// ===============================================================
export const FormatriceCard = () => (
  <div
    className="flex gap-4 items-start p-4 rounded-lg"
    style={{
      backgroundColor: "#F5F7FA",
      borderLeft: "4px solid #F07B1D",
      borderRadius: "8px",
    }}
    data-testid="formatrice-card"
  >
    <img
      src={MARYSE_PHOTO}
      alt="Maryse GALITA — Fondatrice MGB School"
      style={{
        width: "60px",
        height: "60px",
        borderRadius: "50%",
        objectFit: "cover",
        flexShrink: 0,
        border: "2px solid #F07B1D",
      }}
    />
    <div className="flex-1 min-w-0">
      <p className="font-bold text-[#003087] text-sm mb-2">
        👩‍🏫 Votre formatrice — Maryse GALITA
      </p>
      <ul className="text-xs text-gray-700 space-y-0.5 mb-2 leading-snug">
        <li>Formation Ingénieure d'affaires commerce international + DU commerce extérieur, droit, gestion</li>
        <li>20 ans chef d'entreprise transport (Jet Courses · Guadeloupe + Orly)</li>
        <li>Agrément douane reconnu au niveau européen</li>
        <li>Enseignante Économie-Gestion · Bac Pro OTM</li>
        <li>Candidate Agrégation Économie-Gestion 2025</li>
        <li>Formatrice professionnelle certifiée</li>
        <li>Fondatrice MGB School et COLIMEDIA</li>
      </ul>
      <p className="text-xs italic text-[#003087] mb-2">
        « J'enseigne ce que j'ai vécu, pas ce que j'ai lu. »
      </p>
      <Link
        to="/a-propos"
        className="text-xs font-bold text-[#F07B1D] hover:underline"
      >
        En savoir plus →
      </Link>
    </div>
  </div>
);

// ===============================================================
// Bloc "Ce que vous recevez exactement" — détaille les fichiers
// selon la catégorie de formation.
// ===============================================================
const FILE_LISTS = {
  dissertation: [
    "Méthodologie complète + structure des corrigés (PDF)",
    "Document 6 auteurs majeurs PDF (Schumpeter, Drucker, Mintzberg, Crozier, Castel, Argyris & Schön)",
    "10 dissertations rédigées PDF + 10 sujets avec plans approfondis PDF",
    "20 sujets prioritaires commentés PDF",
    "Quiz interactifs par module + quiz final, corrigés détaillés (espace apprenant + PDF)",
    "Certificat de réalisation MGB School",
  ],
  otmpack: [
    "8 modules PDF complets (objectifs, cours, quiz d'auto-évaluation + corrigés)",
    "Bonus : documents professionnels types (CMR, B/L, AWB, facture, packing list…)",
    "Bonus : fiches mémo & révision rapide, exercices corrigés type examen",
    "Bonus : simulations agent d'exploitation, guide méthodologie examen, emploi & alternance",
    "Quiz interactifs dans l'espace apprenant + certificat de réalisation MGB School",
  ],
  otm: [
    "Support PDF professionnel du module",
    "Documents professionnels réels (CMR, Bill of Lading, AWB, DAU…)",
    "Exercices corrigés PDF",
    "Quiz de validation",
    "Certificat de réalisation MGB School",
  ],
  entrepreneuriat: [
    "Support PDF professionnel du module",
    "Fiches pratiques et outils",
    "Exercices corrigés PDF",
    "Quiz de validation",
    "Certificat de réalisation MGB School",
  ],
};

export const inferReceiveCategory = (formation) => {
  if (!formation) return "entrepreneuriat";
  if (formation.id === "F16") return "dissertation";
  if (formation.id === "OTM-PACK") return "otmpack";
  const d = (formation.domain || "").toLowerCase();
  if (d.includes("transport") || d.includes("logistique") || d.includes("supply")) {
    return "otm";
  }
  return "entrepreneuriat";
};

export const RecevezBlock = ({ formation, category }) => {
  const cat = category || inferReceiveCategory(formation);
  const files = FILE_LISTS[cat] || FILE_LISTS.entrepreneuriat;
  return (
    <div
      className="p-5 md:p-6 rounded-xl"
      style={{
        backgroundColor: "#FFFFFF",
        border: "1px solid #E2E8F0",
      }}
      data-testid="recevez-block"
    >
      <h3 className="font-heading text-lg md:text-xl font-bold text-[#003087] mb-3 inline-block pb-1 relative">
        📦 Ce que vous recevez exactement
        <span className="absolute left-0 bottom-0 w-12 h-[3px] bg-[#F07B1D] rounded-full"></span>
      </h3>
      <p className="text-sm text-gray-700 mb-3 leading-relaxed mt-2">
        📧 Dans les minutes suivant votre paiement, vous recevez un e-mail à votre adresse avec :
      </p>
      <ul className="space-y-1.5">
        {files.map((f) => (
          <li
            key={f}
            className="flex items-start gap-2 text-sm text-gray-700"
          >
            <span className="text-[#F07B1D] font-bold mt-0.5">✓</span>
            <span>{f}</span>
          </li>
        ))}
      </ul>
      <p
        className="text-xs italic mt-4 p-3 rounded-lg"
        style={{
          backgroundColor: "#E3F2FD",
          color: "#003087",
        }}
      >
        Tous les supports sont des PDF professionnels téléchargeables (modules, documents types, fiches, exercices corrigés). Accès à vie — aucune limite de temps.
      </p>
    </div>
  );
};

// ===============================================================
// Section "Ils nous font confiance" — 3 placeholders en attente
// de témoignages réels.
// ===============================================================
export const TestimonialsPlaceholder = () => (
  <section className="py-12 bg-white" data-testid="testimonials-placeholder">
    <div className="container-custom max-w-5xl">
      <div className="text-center mb-8">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-[#003087] mb-2">
          Ils nous font confiance
        </h2>
        <p className="text-sm text-gray-500">
          Notre communauté grandit chaque jour — partagez votre expérience.
        </p>
      </div>
      <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 mb-8">
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className="p-5 rounded-lg flex flex-col items-center text-center"
            style={{
              backgroundColor: "#F5F7FA",
              borderLeft: "4px solid #F07B1D",
            }}
          >
            <div className="text-yellow-400 text-sm mb-3">⭐⭐⭐⭐⭐</div>
            <div
              className="w-12 h-12 rounded-full mb-3"
              style={{ backgroundColor: "#CBD5E1" }}
              aria-hidden="true"
            />
            <p className="text-xs italic text-gray-500 leading-relaxed">
              Témoignage en cours de collecte — Soyez parmi les premiers à partager votre expérience MGB School.
            </p>
          </div>
        ))}
      </div>
      <div className="text-center">
        <a
          href="mailto:contact@mgbschool.fr?subject=Mon%20avis%20sur%20MGB%20School"
          className="inline-block bg-[#F07B1D] hover:bg-[#D96A0F] text-white font-bold px-6 py-3 rounded-lg text-sm transition-colors"
          data-testid="leave-review-btn"
        >
          Laisser un avis →
        </a>
      </div>
    </div>
  </section>
);
